import { Injectable, Logger, NotFoundException, OnApplicationBootstrap } from '@nestjs/common';
import { OLT } from '@ip6m/types';
import * as fs from 'fs';
import { homedir } from 'os';

@Injectable()
export class OltDB implements OnApplicationBootstrap {

  private default_data: OLT[] = [
    {
      'name': 'Example OLT 1',
      'ipaddress': '192.168.1.1',
      'read community': 'public123',
      'write community': 'private123',
      'type': 'huawei',
      'datacollector': true,
      'cms database': null,
      'gpsLatitude': 48.02578,
      'gpsLongitude': 21.81436
    },
    {
      'name': 'Example OLT 2',
      'ipaddress': '192.168.1.2',
      'read community': 'public123',
      'write community': 'private123',
      'type': 'huawei',
      'datacollector': false,
      'cms database': null,
      'gpsLatitude': 48.02578,
      'gpsLongitude': 21.81436
    }
  ]
  private OLTs: OLT[];
  private Error: string = null;

  onApplicationBootstrap() {
    this.readConfigFileSync();
  }

  private readConfigFileSync() {
    const filename = homedir() + '/.olt_database.json';
    this.Error = null;
    let fileData = null;
    try {
      fileData = fs.readFileSync(filename);
      try {
        this.OLTs = JSON.parse(fileData.toString());
      } catch (error) {
        console.log('There has been an error parsing your JSON.')
        console.log(error);
        this.Error = error.toString();
      }
    } catch (error) {
      if (error.code === 'ENOENT') {
        fs.writeFileSync(filename, JSON.stringify(this.default_data, null, 2));
        this.OLTs = this.default_data;
      }
      else {
        this.Error = error.toString();
      }
    }
  }

  get getOlts() {
    this.readConfigFileSync();
    if (this.Error) {
      throw new NotFoundException(this.Error);
    }
    return this.OLTs;
  }

  getDataCollectorOLTs(): number[] {
    let result: number[] = [];

    this.readConfigFileSync();
    if (this.Error) {
      throw new NotFoundException(this.Error);
    }
    for(let i=0; i<this.OLTs.length; i++) {
      if (this.OLTs[i].datacollector) {
        result.push(i);
      }
    }
    return result;
  }

  getOlt(id: number): OLT {
    if (id >= this.OLTs.length) {
      throw new NotFoundException('No such OLT');
    } else {
      return this.OLTs[id];
    }
  }
  getOltName(id: number): string {
    if (id >= this.OLTs.length) {
      throw new NotFoundException('No such OLT');
    } else {
      return JSON.stringify(this.OLTs[id].name);
    }
  }

}
